import { render, staticRenderFns } from "./toptovar.vue?vue&type=template&id=787d8bc5&"
import script from "./toptovar.vue?vue&type=script&lang=js&"
export * from "./toptovar.vue?vue&type=script&lang=js&"
import style0 from "./toptovar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports